"use strict";
// Copyright © Veeam Software Group GmbH
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledLabelGroup = exports.StyledLabelGroupInnerLayout = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
const Label_1 = require("../../../FieldLayout/components/Label/Label");
const FieldLayout_1 = require("../../../FieldLayout/FieldLayout");
exports.StyledLabelGroupInnerLayout = styled_components_1.default.td `
    padding: 0;
    outline: 0;
`;
exports.StyledLabelGroup = styled_components_1.default.tr `
    > ${Label_1.Label.selector} ${FieldLayout_1.FieldLayout.selector} {
        margin-right: ${({ theme }) => theme.spacing.s};
    }

    > ${Label_1.Label.selector} > * {
        transform: translateY(${({ hasTopOffset }) => (hasTopOffset ? '20px' : '0')});
    }
`;
//# sourceMappingURL=LabelGroup.styles.js.map